import * as React from 'react';

import { Text } from '@components/common';
import { default as Select, SelectOption, SelectProps } from '@components/common/Select';

const SHARE_ACCESS_OPTIONS: SelectOption<any>[] = [
  { value: 'default', label: `Default - Follow calendar provider's settings` },
  { value: 'public', label: `Always Public — Event details visible to all teammates in calendar events` },
  { value: 'private', label: `Always Private - Event details hidden from teammates in calendar events` }
];

type Props = Omit<SelectProps<any>, 'options'>;

const renderOption = (v: (typeof SHARE_ACCESS_OPTIONS)[0]) => (
  <div className='flex items-center space-x-2 truncate'>
    <Text h='400' truncate>
      {v.label}
    </Text>
  </div>
);

export const CalendarEventPrivacySelect: React.FC<React.PropsWithChildren<Props>> = ({ ...rest }) => (
  <Select<any>
    {...rest}
    data-testid='select-button'
    options={SHARE_ACCESS_OPTIONS}
    renderSelected={renderOption}
    renderLabel={renderOption}
    wrapperClass='w-full max-w-xl'
  />
);
